import { render, staticRenderFns } from "./RestoreAccountModal.vue?vue&type=template&id=daa6ce9a&"
import script from "./RestoreAccountModal.vue?vue&type=script&lang=js&"
export * from "./RestoreAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports